import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useAlert, types } from 'react-alert';
import { useHistory } from 'react-router-dom';
import Grid from '@material-ui/core/Grid/Grid';
import FormControl from '@material-ui/core/FormControl';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';
import { Button } from '@material-ui/core';
import { PageTitle, PaperWithTitle, PrimaryButton, ConfirmDialog } from '../../../components';
import { useClinic, useClinicUser, useMaster } from '../../../../model/hooks';
import { Constants } from '../../../../common/constants';
import { getLabelPlanPeriod, getLabelPlanConstantCost, isPlanHaveRenewalDate } from '../../../common/helper';
import { COLOR } from '../../../common/constants';
import { DateHelper } from '../../../../common/helper/DateHelper';
export const ChangePlan = () => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    const { t } = useTranslation();
    const reactAlert = useAlert();
    const history = useHistory();
    const { registerPlan, cancelPlan, registerCoupon, loading, loadingCoupon, loadContractRenewal } = useClinic();
    const { paymentClinic } = useClinicUser();
    const { paymentMaster } = useMaster();
    const { billingPlanType, billingPlanPaymentMethodType } = Constants;
    const [plan, setPlan] = useState(billingPlanType.free);
    const [isOpenConfirmCalcel, setIsOpenConfirmCalcel] = useState(false);
    const [isOpenConfirmChangePlan, setIsOpenConfirmChangePlan] = useState(false);
    const [isOpenConfirmCoupon, setIsOpenConfirmCoupon] = useState(false);
    const [couponId, setCouponId] = useState('');
    const [contractRenewalDate, setContractRenewalDate] = useState('');
    const [isTrial, setIsTrial] = useState(false);
    const [isRemainContract, setIsRemainContract] = useState(false); // フリープランで前回の契約期間がまだ残っているかどうか
    const planType = (_a = paymentClinic) === null || _a === void 0 ? void 0 : _a.planType;
    useEffect(() => {
        var _a;
        // ラジオボタンの初期値設定
        setPlan((_a = paymentClinic) === null || _a === void 0 ? void 0 : _a.planType);
        // お手軽プラン、使い放題プランの場合、更新日時を取得して設定
        if (!paymentClinic)
            return;
        if (isPlanHaveRenewalDate(paymentClinic.planType)) {
            const f = async () => {
                var _a, _b, _c;
                const result = await loadContractRenewal();
                // 無料期間以外の場合は更新日時を設定、無料期間の場合はフラグを設定
                if ((_a = result.data) === null || _a === void 0 ? void 0 : _a.isTrial) {
                    setIsTrial(true);
                }
                else {
                    setContractRenewalDate(DateHelper.toStringDateOnly(new Date((_c = (_b = result.data) === null || _b === void 0 ? void 0 : _b.renewalDateAt, (_c !== null && _c !== void 0 ? _c : ''))), 'yyyy年M月d日'));
                }
            };
            f();
        }
        // 前回プランがお手軽プラン、使い放題プランの場合、更新日時が未来日(まだ契約期間が残っている)かどうか
        if (isPlanHaveRenewalDate(paymentClinic.prevPlanType)) {
            const f = async () => {
                var _a;
                const result = await loadContractRenewal();
                // 契約が残っている場合、日時とフラグを設定
                const renewalDateAt = new Date((_a = result.data) === null || _a === void 0 ? void 0 : _a.renewalDateAt);
                if (DateHelper.isAfter(renewalDateAt, new Date())) {
                    setIsRemainContract(true);
                    setContractRenewalDate(DateHelper.toStringDateOnly(renewalDateAt, 'yyyy年M月d日'));
                }
            };
            f();
        }
    }, [paymentClinic]);
    const onChangePlan = (e) => {
        setPlan(parseInt(e.target.value, 10));
    };
    const onClickUpdatePlan = async () => {
        var _a;
        try {
            await registerPlan(plan, billingPlanPaymentMethodType.creditCard);
            reactAlert.show(t('更新しました'), { type: types.SUCCESS });
            history.push('/home/account');
        }
        catch (e) {
            if ((_a = e) === null || _a === void 0 ? void 0 : _a.message) {
                reactAlert.show(e.message, { type: types.ERROR });
            }
            else {
                reactAlert.show(t('エラーが発生しました'), { type: types.ERROR });
            }
        }
    };
    const onClickCancelPlan = async () => {
        var _a;
        try {
            await cancelPlan();
            reactAlert.show(t('更新しました'), { type: types.SUCCESS });
            history.push('/home/account');
        }
        catch (e) {
            if ((_a = e) === null || _a === void 0 ? void 0 : _a.message) {
                reactAlert.show(e.message, { type: types.ERROR });
            }
            else {
                reactAlert.show(t('エラーが発生しました'), { type: types.ERROR });
            }
        }
    };
    const onClickRegisterCoupon = async () => {
        var _a;
        try {
            await registerCoupon(couponId);
            reactAlert.show(t('登録しました'), { type: types.SUCCESS });
            setIsOpenConfirmCoupon(false);
            setCouponId('');
        }
        catch (e) {
            if ((_a = e) === null || _a === void 0 ? void 0 : _a.message) {
                reactAlert.show(e.message, { type: types.ERROR });
            }
            else {
                reactAlert.show(t('エラーが発生しました'), { type: types.ERROR });
            }
        }
    };
    const onOpenCancelDialog = () => setIsOpenConfirmCalcel(true);
    const onCloseCancelDialog = () => setIsOpenConfirmCalcel(false);
    const onOpenChangePlanDialog = () => setIsOpenConfirmChangePlan(true);
    const onCloseChangePlanDialog = () => setIsOpenConfirmChangePlan(false);
    const onOpenCouponDialog = () => setIsOpenConfirmCoupon(true);
    const onCloseCouponDialog = () => setIsOpenConfirmCoupon(false);
    return (React.createElement(React.Fragment, null,
        React.createElement(PageTitle, null, t('利用プラン')),
        React.createElement(SGrid, { container: true, justify: "center" },
            React.createElement(Grid, { item: true, xs: 12, md: 6 },
                isRemainContract && (React.createElement("div", null,
                    React.createElement(SBoldText, null,
                        "\u6B21\u56DE\u66F4\u65B0\u65E5\uFF1A",
                        contractRenewalDate),
                    React.createElement("p", { style: { margin: 0 } }, t('次回更新日時までは引き続きご利用いただけます。')),
                    React.createElement("p", null, t('別のプランに変更する場合は次回更新日時を過ぎてからお申し込みください。')))),
                React.createElement(PaperWithTitle, { title: planType === billingPlanType.free ? 'プランを選択してください' : '利用プラン', titleAlign: "center" },
                    React.createElement(SGrid, { container: true, spacing: 3, justify: "center" },
                        React.createElement(Grid, { item: true, xs: 11 },
                            React.createElement(FormControl, { component: "fieldset" },
                                React.createElement(RadioGroup, { name: "plan", value: plan, onChange: onChangePlan },
                                    React.createElement(SRow, null,
                                        React.createElement(FormControlLabel, { value: billingPlanType.standard, control: React.createElement(Radio, { color: "primary" }), label: t('お手軽プラン'), disabled: planType !== billingPlanType.free || isRemainContract }),
                                        planType === billingPlanType.free ? (React.createElement(STopicText, null, `${_d = (_c = (_b = paymentMaster) === null || _b === void 0 ? void 0 : _b.standardPlanFeature) === null || _c === void 0 ? void 0 : _c.trialDays, (_d !== null && _d !== void 0 ? _d : '')}${t('日間無料キャンペーン中！')}`)) : (React.createElement(React.Fragment, null, planType === billingPlanType.standard && (React.createElement(SRow, null,
                                            React.createElement(SNowPlanLabel, null, "\u73FE\u5728\u306E\u30D7\u30E9\u30F3"),
                                            contractRenewalDate !== '' && (React.createElement(SUpdateDateText, null, `次回更新日時： ${contractRenewalDate}`)),
                                            isTrial && React.createElement(SUpdateDateText, null, t('現在無料期間中'))))))),
                                    React.createElement(SCostLabel, null, `${getLabelPlanPeriod(t, (_f = (_e = paymentMaster) === null || _e === void 0 ? void 0 : _e.standardPlanFeature) === null || _f === void 0 ? void 0 : _f.periodWithMonthly)} ${getLabelPlanConstantCost((_h = (_g = paymentMaster) === null || _g === void 0 ? void 0 : _g.standardPlanFeature) === null || _h === void 0 ? void 0 : _h.constantCost)}円(税込)`),
                                    React.createElement(SFormHelperText, null, t('月額費用のみで使い放題のプランです。まずはお手軽な金額で始めたい、また繁忙期だけ求人を出したい場合などにおすすめです。')),
                                    React.createElement(SRow, null,
                                        React.createElement(FormControlLabel, { value: billingPlanType.professional, control: React.createElement(Radio, { color: "primary" }), label: t('使い放題プラン'), disabled: planType !== billingPlanType.free || isRemainContract }),
                                        planType === billingPlanType.free ? (React.createElement(STopicText, null, `${_l = (_k = (_j = paymentMaster) === null || _j === void 0 ? void 0 : _j.professionalPlanFeature) === null || _k === void 0 ? void 0 : _k.trialDays, (_l !== null && _l !== void 0 ? _l : '')}${t('日間無料キャンペーン中！')}`)) : (React.createElement(React.Fragment, null, planType === billingPlanType.professional && (React.createElement(SRow, null,
                                            React.createElement(SNowPlanLabel, null, "\u73FE\u5728\u306E\u30D7\u30E9\u30F3"),
                                            contractRenewalDate !== '' && (React.createElement(SUpdateDateText, null, `次回更新日時： ${contractRenewalDate}`)),
                                            isTrial && React.createElement(SUpdateDateText, null, t('現在無料期間中'))))))),
                                    React.createElement(SCostLabel, null, `${getLabelPlanPeriod(t, (_o = (_m = paymentMaster) === null || _m === void 0 ? void 0 : _m.professionalPlanFeature) === null || _o === void 0 ? void 0 : _o.periodWithMonthly)} ${getLabelPlanConstantCost((_q = (_p = paymentMaster) === null || _p === void 0 ? void 0 : _p.professionalPlanFeature) === null || _q === void 0 ? void 0 : _q.constantCost)}円(税込)`),
                                    React.createElement(SFormHelperText, null, t('費用を気にせずご利用いただける使い放題のプランです。定期的に求人を出す予定がある場合にはこちらのプランがおすすめです。'))))),
                        planType === billingPlanType.free && (React.createElement(Grid, { item: true, xs: 4, style: { marginTop: '16px' } },
                            React.createElement(PrimaryButton, { onClick: onOpenChangePlanDialog, loading: loading, disabled: ((_r = paymentClinic) === null || _r === void 0 ? void 0 : _r.planType) === plan || isRemainContract, fullWidth: true }, t('適用する')))))),
                planType === billingPlanType.free ? (React.createElement(SHelperText, null, t('プラン適用後、即時求人掲載が可能です。またプランはいつでもご解約いただけます。'))) : (React.createElement(SHelperText, null, t('プランを変更する場合は、一度解約をしてから再度プラン選択をしてください。'))),
                React.createElement(SSpacer, null),
                planType !== billingPlanType.free && (React.createElement("div", { style: { textAlign: 'center' } },
                    React.createElement(PaperWithTitle, { title: "\u30AF\u30FC\u30DD\u30F3\u3092\u9069\u7528", titleAlign: "center" },
                        React.createElement(SGrid, { container: true, spacing: 3, justify: "center" },
                            React.createElement(Grid, { item: true, xs: 11 },
                                React.createElement("p", { style: { margin: 0 } }, t('クーポンコードをお持ちの方は以下に入力してください。')),
                                React.createElement("p", null, t('すでにクーポンを適用中の場合は、新しく入力したクーポンのみが適用されます。')),
                                React.createElement(TextField, { required: true, label: t('クーポンコード'), value: couponId, onChange: (e) => setCouponId(e.target.value), fullWidth: true })),
                            React.createElement(Grid, { item: true, xs: 4, style: { marginTop: '16px' } },
                                React.createElement(PrimaryButton, { onClick: onOpenCouponDialog, loading: loadingCoupon, disabled: couponId === '', fullWidth: true }, t('適用する'))))),
                    React.createElement(SSpacer, null),
                    React.createElement(SCancelButton, { onClick: onOpenCancelDialog, disabled: loading }, t('解約する')))))),
        React.createElement(ConfirmDialog, { isOpen: isOpenConfirmCalcel, title: t('プランを解約しますか？'), negativeLabel: t('キャンセル'), positiveLabel: t('解約する'), isCancel: true, onClose: onCloseCancelDialog, onClickNegative: onCloseCancelDialog, onClickPositive: onClickCancelPlan, loading: loading },
            React.createElement("p", null, t(
            // 以下の文言から変更 'お手軽プラン、使い放題プランの場合は次回更新日時まで引き続きお使いいただけます。成果報酬プランの場合、現在掲載中の求人は非公開となります。
            'お手軽プラン、使い放題プランの場合は次回更新日時まで引き続きお使いいただけます。'))),
        React.createElement(ConfirmDialog, { isOpen: isOpenConfirmChangePlan, title: t('プランを適用しますか？'), negativeLabel: t('キャンセル'), positiveLabel: t('適用する'), isCancel: true, onClose: onCloseChangePlanDialog, onClickNegative: onCloseChangePlanDialog, onClickPositive: onClickUpdatePlan, loading: loading },
            React.createElement("p", null, t('プラン適用後、即時求人掲載が可能です。またプランはいつでもご解約いただけます。'))),
        React.createElement(ConfirmDialog, { isOpen: isOpenConfirmCoupon, title: t('クーポン適用'), negativeLabel: t('キャンセル'), positiveLabel: t('適用する'), isCancel: true, onClose: onCloseCouponDialog, onClickNegative: onCloseCouponDialog, onClickPositive: onClickRegisterCoupon, loading: loadingCoupon },
            React.createElement("p", null, t('クーポンを適用しますか？')))));
};
const SGrid = styled(Grid) `
  padding-top: 32px;
  padding-bottom: 32px;
`;
const SRow = styled.div `
  display: flex;
  align-items: center;
`;
const SCostLabel = styled.p `
  font-weight: bold;
  margin-bottom: 4px;
`;
const SCostLabelSmall = styled.p `
  font-weight: bold;
  font-size: 0.9rem;
  margin-bottom: 4px;
`;
const SFormHelperText = styled(FormHelperText) `
  &&& {
    margin-top: 0;
    margin-bottom: 16px;
  }
`;
const STopicText = styled.p `
  margin-bottom: 4px;
  font-size: 0.9rem;
  font-weight: bold;
  color: ${COLOR.CHERRY_RED700};
`;
const SHelperText = styled.p `
  font-size: 0.9rem;
  margin-top: 16px;
`;
const SUpdateDateText = styled.p `
  font-size: 0.8rem;
  margin-bottom: 0;
  margin-left: 16px;
  coor: ${COLOR.GRAY_300};
`;
const SSpacer = styled.div `
  height: 40px;
`;
const SNowPlanLabel = styled.div `
  background-color: ${COLOR.CHERRY_RED700};
  width: 100px;
  height: 24px;
  color: #fff;
  font-size: 0.8rem;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
`;
const SCancelButton = styled(Button) `
  &&& {
    color: ${COLOR.CHERRY_RED700};
    font-weight: bold;
  }
`;
const SBoldText = styled.p `
  font-weight: bold;
  font-size: 1.2rem;
  margin-bottom: 6px;
`;
